/* The Atelier: HelpfulCrowd customer photos (sections/at-reviews.liquid, loaded defer by the section).
   The app's thumbnails are 180x100 landscape crops of portrait photos, so heads and hems were cut off. As on the live
   theme, each displayed photo tile swaps to the app's own uncropped copy: cdn.helpfulcrowdcdn.com
   "<id>.thumb.jpg" -> "<id>.large.jpg" (810x1080), legacy Cloudinary "c_fill,g_auto,h_100,w_180" -> "w_1100". The
   copies start downloading as soon as the app inserts the tiles (not when they near the screen), and the crop stays
   on show (data-at-photo="loading") until its copy has downloaded and decoded, so a tile is never an empty box. A copy
   that fails leaves the crop, shown whole (data-at-fit="contain"); a photo far from portrait (landscape) is marked
   data-at-fit="contain" too, so nothing is cut. Only tiles that are displayed are swapped (the strip shows four, the
   rest are hidden and never fetched); photos in the reviews behind "Read all" swap when they are shown and near the
   screen.
   Also: the strip's tiles become keyboard buttons, and when the app has more than four photos one "Show all 11 photos"
   link under the strip opens the app's lightbox at the first photo, which pages through all of them. Its words are the
   gallery's (locale atelier.product.show_all_photos, the section's data-all-photos) with the number from the app's own
   "11 photos" count, or "More photos" (data-more-photos) if the app shows no count; its arrow comes from the section's
   template.at-reviews-photos-icon.
   Review dates read "8 September 2026" (the app's "September 08, 2026", from its own <time datetime>). */
(function () {
  var roots = document.querySelectorAll('.at-reviews-widget');
  if (!roots.length) return;

  // The app delegates clicks from divs. Real buttons give touch, keyboard and assistive technology the same
  // controls; keep its classes and handlers so paging, swipe and closing still belong to HelpfulCrowd.
  var photoOpener = null;
  var pendingPhoto = null;
  var photoTimer;
  function clearPendingPhoto() {
    clearTimeout(photoTimer);
    if (pendingPhoto) pendingPhoto.opener.removeAttribute('aria-busy');
    pendingPhoto = null;
  }
  function openPendingPhoto() {
    if (!pendingPhoto) return;
    var pending = pendingPhoto;
    if (!pending.tile.isConnected || Date.now() - pending.since > 30000) return clearPendingPhoto();
    if (typeof window.lcl_open !== 'function' || window.lcl_is_active || document.getElementById('lcl_wrap')) {
      // HelpfulCrowd exposes no dependency-ready event. Only a requested open polls, including its closing phase.
      photoTimer = setTimeout(openPendingPhoto, 100);
      return;
    }
    clearPendingPhoto();
    photoOpener = pending.opener;
    pending.tile.click();
  }
  document.addEventListener('click', function (event) {
    var tile = event.target.closest && event.target.closest('.at-reviews .hc-media__medium');
    if (!tile) return;
    photoOpener = document.activeElement.closest('.at-reviews-photos__btn') || tile;
    var img = tile.querySelector('img');
    if (img && img.complete && img.naturalWidth) {
      document.body.style.setProperty('--at-review-preview', 'url("' + img.currentSrc.replace(/"/g, '%22') + '")');
    } else {
      document.body.style.removeProperty('--at-review-preview');
    }
    var wrap = document.getElementById('lcl_wrap');
    if (typeof window.lcl_open !== 'function' || (wrap && wrap.classList.contains('lcl_is_closing')) || (!wrap && window.lcl_is_active)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      clearPendingPhoto();
      pendingPhoto = { tile: tile, opener: photoOpener, since: Date.now() };
      photoOpener.setAttribute('aria-busy', 'true');
      openPendingPhoto();
    }
  }, true);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') clearPendingPhoto();
  });
  window.addEventListener('pagehide', clearPendingPhoto);

  function prepareViewer(wrap) {
    if (wrap.hasAttribute('data-at-controls')) return;
    wrap.dataset.atControls = '';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.setAttribute('aria-label', roots[0].dataset.photoViewer);
    // Use the theme's scroll-lock class too: its floating offer teaser must not cover the viewer's Next control.
    document.body.classList.add('overflow-hidden');
    wrap.querySelectorAll('#lcl_nav_cmd > div:is(.lcl_prev,.lcl_next,.lcl_close)').forEach(function (control) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = control.className;
      button.setAttribute('aria-label', control.title);
      button.innerHTML = control.innerHTML;
      control.replaceWith(button);
    });
    var focused = false;
    // HC can replace the controls during opening; use the current close button if focus falls back to the page.
    wrap.addEventListener('focusout', function () {
      queueMicrotask(function () {
        if (wrap.isConnected && !wrap.inert && !wrap.classList.contains('lcl_is_closing') && document.activeElement === document.body) {
          updateViewer();
        }
      });
    });
    wrap.addEventListener('transitionend', function (event) {
      if (event.target.id === 'lcl_contents_wrap' && event.propertyName === 'opacity') updateViewer();
    });
    function updateViewer() {
      // The app inserts the photo and its review separately, and replaces both when she pages through the viewer.
      var name = wrap.querySelector('.hc-author__text .bold');
      var thumb = photoOpener && photoOpener.querySelector('img');
      var description = name ? roots[0].dataset.photoViewer + ' — ' + name.textContent.trim() :
        (thumb && thumb.alt) || roots[0].dataset.photoViewer;
      wrap.querySelectorAll('#lcl_elem_wrap img').forEach(function (img) { img.alt = description; });
      // Sizing ends before the contents fade in. Retire the preview only once the actual photo is opaque, and never
      // bring it back under a different customer photo when the app pages through the viewer.
      var photo = wrap.querySelector('#lcl_elem_wrap img');
      var contents = wrap.querySelector('#lcl_contents_wrap');
      if (!wrap.classList.contains('at-photo-ready') && !wrap.classList.contains('lcl_first_sizing') &&
          photo && photo.complete && photo.naturalWidth && contents && getComputedStyle(contents).opacity === '1') {
        wrap.classList.add('at-photo-ready');
      }
      var close = wrap.querySelector('.lcl_close');
      if (wrap.inert || !wrap.classList.contains('lcl_shown') || !getTabStops(wrap).includes(close)) return;
      if (!focused) {
        inertPage(wrap, { isOpen: function () { return !wrap.classList.contains('lcl_is_closing'); }, close: function () { wrap.querySelector('.lcl_close').click(); } });
      }
      if (!focused || document.activeElement === document.body) {
        trapFocus(wrap, close);
        focused = document.activeElement === close;
      }
    }
    var closing = new MutationObserver(function () {
      if (!wrap.classList.contains('lcl_is_closing')) return updateViewer();
      closing.disconnect();
      releasePage(wrap);
      document.body.classList.remove('overflow-hidden');
      removeTrapFocus(photoOpener && photoOpener.isConnected ? photoOpener : null);
    });
    closing.observe(wrap, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    updateViewer();
  }
  new MutationObserver(function (list) {
    list.forEach(function (change) {
      change.addedNodes.forEach(function (node) { if (node.id === 'lcl_wrap') prepareViewer(node); });
    });
  }).observe(document.body, { childList: true });

  function largeSrc(src) {
    try {
      var u = new URL(src, location.href);
      if (/(^|\.)helpfulcrowdcdn\.com$/.test(u.hostname) && /\.thumb\.jpe?g$/i.test(u.pathname)) {
        u.pathname = u.pathname.replace(/\.thumb\.(jpe?g)$/i, '.large.$1');
      } else if (u.hostname === 'res.cloudinary.com' && u.pathname.indexOf('/helpfulcrowd/image/upload/') === 0) {
        u.pathname = u.pathname.replace(/\/c_fill,g_auto,h_\d+,w_\d+\//, '/w_1100/');
      }
      return u.href === src ? null : u.href;
    } catch (e) {
      return null;
    }
  }

  function fit(el, w, h) {
    if (!w || !h) return;
    var r = w / h;
    if (r > 0.9 || r < 0.5) el.setAttribute('data-at-fit', 'contain');
    else el.removeAttribute('data-at-fit');
  }

  function swap(img) {
    var big = largeSrc(img.getAttribute('src') || '');
    if (!big) {
      img.setAttribute('data-at-photo', 'thumb');
      return;
    }
    var original = img.getAttribute('src');
    var pre = new Image();
    pre.fetchPriority = 'low';
    pre.src = big;
    pre.decode().then(function () {
      if (!img.isConnected || img.getAttribute('src') !== original) return;
      img.src = big;
      fit(img, pre.naturalWidth, pre.naturalHeight);
      img.setAttribute('data-at-photo', 'large');
    }, function () {
      img.setAttribute('data-at-fit', 'contain');
      img.setAttribute('data-at-photo', 'thumb');
    });
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      swap(e.target);
    });
  }, { rootMargin: '400px 0px' }) : null;

  // Review dates the Australian way: the app writes "September 08, 2026"; its <time datetime> carries the store-time
  // date, so "8 September 2026" is read from that (the date part only, no time-zone shift). Anything unexpected is left
  // as the app wrote it.
  var dateFmt = window.Intl ? new Intl.DateTimeFormat('en-AU', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' }) : null;
  function localDate(el) {
    el.setAttribute('data-at-date', '');
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(el.getAttribute('datetime') || '');
    var text = el.firstChild;
    if (!dateFmt || !m || el.childNodes.length !== 1 || text.nodeType !== 3) return;
    text.nodeValue = dateFmt.format(new Date(Date.UTC(+m[1], +m[2] - 1, +m[3]))); // same text node, so the app can still update it
  }

  function prepare(root) {
    root.querySelectorAll('.hc-stars').forEach(function (stars) {
      if (!stars.querySelector(':scope > svg')) return;
      var rating = stars.closest('.hc-product-rating');
      var score = rating && rating.querySelector('.hc-product-rating__text');
      var value = score ? Number(score.textContent.trim()) :
        stars.querySelectorAll('.hc-icon--star').length + stars.querySelectorAll('.hc-icon--star-half-o').length / 2;
      if (value > 0 && value <= 5) {
        stars.setAttribute('role', 'img');
        stars.setAttribute('aria-label', root.dataset.ratingLabel.replace('[rating]', value));
      }
      stars.querySelectorAll('svg').forEach(function (star) { star.setAttribute('aria-hidden', 'true'); });
    });
    root.querySelectorAll('time[datetime]:not([data-at-date])').forEach(localDate);
    root.querySelectorAll('.hc-media__thumb').forEach(function (el) {
      if (el.hasAttribute('data-at-photo')) return;
      if (el.tagName === 'VIDEO') {
        el.setAttribute('data-at-photo', 'video');
        var set = function () { fit(el, el.videoWidth, el.videoHeight); };
        if (el.readyState >= 1) set(); else el.addEventListener('loadedmetadata', set, { once: true });
        return;
      }
      if (!largeSrc(el.getAttribute('src') || '')) {
        el.setAttribute('data-at-photo', 'thumb');
        el.setAttribute('data-at-fit', 'contain');
        return;
      }
      el.setAttribute('data-at-photo', 'loading');
      if (!io || el.getClientRects().length) swap(el); // displayed: start now
      else io.observe(el); // hidden until "Read all" (or a hidden strip tile, which never shows)
    });
    root.querySelectorAll('.hc-media__medium:not([tabindex])').forEach(function (tile) {
      tile.setAttribute('role', 'button');
      tile.setAttribute('tabindex', '0');
      var img = tile.querySelector('img[alt]');
      if (img && img.alt) tile.setAttribute('aria-label', img.alt);
      tile.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); tile.click(); }
      });
    });
    var strip = root.querySelector('.hc-reviews-media .hc-media');
    var label = root.getAttribute('data-more-photos');
    if (strip && label && strip.children.length > 4 && !strip.parentNode.querySelector('.at-reviews-photos')) {
      var row = document.createElement('p');
      row.className = 'at-reviews-photos';
      var countEl = root.querySelector('.hc-reviews-media__image-count');
      var count = countEl && /\d+/.exec(countEl.textContent);
      var all = root.getAttribute('data-all-photos');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'at-link at-reviews-photos__btn';
      btn.textContent = count && all ? all.replace('[n]', count[0]) : label;
      var icon = root.querySelector('template.at-reviews-photos-icon');
      if (icon) btn.appendChild(icon.content.cloneNode(true));
      btn.addEventListener('click', function () {
        var first = strip.querySelector('.hc-media__medium');
        if (first) first.click();
      });
      row.appendChild(btn);
      strip.after(row);
    }
  }

  // The widget reserves the list's room until HelpfulCrowd renders (at-reviews.liquid sizes it from the review count;
  // at-reviews.css releases it once cards, or the app's "No reviews yet", exist). The first page's real height varies
  // with the length of its three reviews and whether customers added photos (phones: about 450-1330px), so when the
  // app answers the list is shorter or taller than the room kept for it. What the shopper is reading must not move:
  // - Shorter, and its new end would be on the screen (or passed): the widget keeps the reserved height, so the
  //   difference is paper after the list instead of the section below sliding up into view. The paper goes the first
  //   time the whole widget is off the screen (below: nothing visible moves; above: the browser's scroll anchoring
  //   keeps her place). Shorter with its new end still below the screen: nothing that moves can be seen, so the list
  //   simply takes its own height.
  // - Taller: until the list lands the room is left out of the browser's scroll anchoring (at-reviews.liquid:
  //   overflow-anchor: none on the widget until data-at-anchor), so the browser keeps still what shows around it. With
  //   the heading or rating on screen that is them, and the list grows downward, as any page does while it loads. Once
  //   she has scrolled past the room's top it is .at-reviews-end, a 1px dot at the bottom of the reviews body, so the extra height goes
  //   upward, off screen, and the section below stays where she sees it. Chrome, Firefox and Safari (WebKit 26)
  //   anchor; elsewhere the sections below move down as before.
  // Once the list has landed the room takes part in anchoring again, so a later change above (the "Pairs well with"
  // row closing when Rebuy fails) keeps the reviews she is reading still. No timers.
  var releaser = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) return;
      e.target.style.minHeight = '';
      releaser.unobserve(e.target);
    });
  }) : null;

  // Where the page was scrolled before the list landed: reading the widget's box lays the new list out, and the
  // browser's anchoring adjustment is already applied by then, so the room's end on screen is judged from this.
  var lastY = window.scrollY;
  function track() { lastY = window.scrollY; }
  window.addEventListener('scroll', track, { passive: true });

  // The list has landed: the room goes back into anchoring (data-at-anchor). If that end dot is on the screen it is
  // the anchor now, and the steadier one while the app finishes the list over the next few frames, so the room waits
  // for her next touch, wheel or key; otherwise at once, so what she is reading is the anchor from here on.
  var landed = [];
  var inputs = ['touchstart', 'wheel', 'keydown', 'pointerdown'];
  function handBack() {
    landed.splice(0).forEach(function (root) { root.setAttribute('data-at-anchor', ''); });
    inputs.forEach(function (type) { window.removeEventListener(type, handBack, { passive: true }); });
  }
  function settle(root, wrap) {
    var end = wrap && wrap.querySelector('.at-reviews-end');
    var r = end && end.getBoundingClientRect();
    if (!r || r.top >= window.innerHeight || r.bottom <= 0) return root.setAttribute('data-at-anchor', '');
    if (landed.push(root) === 1) inputs.forEach(function (type) { window.addEventListener(type, handBack, { passive: true }); });
  }

  function hold(root, reserved, wrap, failed) {
    if (!reserved || root.dataset.atHeld || (!failed && !root.querySelector('.hc-card__item, .hc-product-tab__no-records'))) return;
    root.dataset.atHeld = '1';
    if (failed) {
      // Nothing has changed yet, so the box can be read as it stands: if any of the room is above the bottom of the
      // screen, letting it go would pull what follows up into view, so it is kept (inline) until it is off screen.
      if (releaser && root.getBoundingClientRect().top < window.innerHeight) {
        root.style.minHeight = reserved + 'px';
        releaser.observe(root);
      }
      root.dataset.atFailed = '1';
      settle(root, wrap);
      return;
    }
    var r = root.getBoundingClientRect();
    var top = r.top + (window.scrollY - lastY);
    var keep = top + r.height < window.innerHeight && r.height < reserved && releaser;
    if (keep) {
      root.style.minHeight = reserved + 'px';
      releaser.observe(root);
    }
    settle(root, wrap);
    if (!document.querySelector('.at-reviews-widget.has-reviews:not([data-at-held])')) window.removeEventListener('scroll', track);
  }

  // If the app's script cannot load (a content blocker, an outage) no list will come, and the reserved room would stay
  // as blank paper under the rating for the whole visit. Its storefront script is added to <head> by Shopify at load;
  // an error on it releases the room the same way a list with no height would (kept while in view, then let go).
  // The same when the script runs but its list request (an XHR to .../tabs.js) fails: the browser's resource timing
  // reports that request when it ends, with its HTTP status in Chrome, Edge and Firefox (responseStatus: 0 for a
  // network error, 4xx/5xx for a server error). Safari reports no status, so there the room stays, as before.
  var failures = [];
  function watchApp() {
    var isApp = function (n) { return n.tagName === 'SCRIPT' && /\/\/app\.helpfulcrowd\.com\/res\//.test(n.src || ''); };
    var failed = function () { failures.splice(0).forEach(function (f) { f(); }); };
    var bind = function (n) { n.addEventListener('error', failed, { once: true }); };
    if (window.PerformanceObserver && (PerformanceObserver.supportedEntryTypes || []).indexOf('resource') > -1) {
      var po = new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (e) {
          if (!/\/\/[^/]*helpfulcrowd\.com\/.*\/tabs\.js/.test(e.name) || typeof e.responseStatus !== 'number') return;
          po.disconnect();
          if (e.responseStatus === 0 || e.responseStatus >= 400) failed();
        });
      });
      po.observe({ type: 'resource', buffered: true });
    }
    var found = [].filter.call(document.scripts, isApp);
    if (found.length) return found.forEach(bind);
    var mo = new MutationObserver(function (list) {
      list.forEach(function (m) {
        [].forEach.call(m.addedNodes, function (n) { if (isApp(n)) { bind(n); mo.disconnect(); } });
      });
    });
    mo.observe(document.head, { childList: true });
  }

  roots.forEach(function (root) {
    var queued = false;
    var reserved = root.classList.contains('has-reviews') && !root.querySelector('.hc-card__item, .hc-product-tab__no-records') ? root.offsetHeight : 0;
    var wrap = reserved ? root.closest('.shopify-section') : null;
    if (!reserved) root.setAttribute('data-at-anchor', ''); // the list was already there
    if (reserved) failures.push(function () { hold(root, reserved, wrap, true); });
    new MutationObserver(function () {
      hold(root, reserved, wrap);
      // Copied review metafields can promise a count the app cannot list: when it shows its empty state, the buy
      // box's rating goes too (atelier.css / at-reviews.css .at-no-reviews). A class, not a page-wide :has().
      if (root.querySelector('.hc-product-tab__no-records')) document.documentElement.classList.add('at-no-reviews');
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; prepare(root); });
    }).observe(root, { childList: true, subtree: true });
    prepare(root);
  });
  if (!document.querySelector('.at-reviews-widget.has-reviews:not([data-at-held])')) window.removeEventListener('scroll', track);
  if (failures.length) watchApp();
})();
